import MuiButton from '@mui/material/Button'

export default function Button({ type, id, name, onClick, style, className, disabled, color }) {
  return (
    <MuiButton
      name={id}
      type={type}
      variant='contained'
      className={className}
      style={{
        fontSize: '16px',
        backgroundColor: disabled ? '#9ca3af' : color ? color : '#d65944',
        color: 'white',
        borderRadius: '30px',
        textTransform: 'none',
        paddingLeft: '20%',
        paddingRight: '20%',
        paddingTop: '10px',
        paddingBottom: '10px',
        fontFamily: 'Poppins, sans-serif',
        fontWeight: 'semi-bold',
        boxShadow: 'none',
        ...style
      }}
      onClick={onClick}
      disabled={disabled}
    >
      {name}
    </MuiButton>
  )
}
